const featureCaps = {
    accounts: { allowed: 1000 },
    personas: { allowed: 1000 },
    targetSegments: { allowed: 1000 },
    decisionMakers: { allowed: 1000 }
};

class TierCapsService {
    constructor(usageData) {
        this.usageData = usageData;
    }

    getFeatureUsage(feature) {
        if (!featureCaps[feature]) {
            throw new Error(`Feature "${feature}" is not supported.`);
        }
        const used = this.usageData?.[feature] || 0; // Fetch actual usage from initialized data
        return { ...featureCaps[feature], used };
    }
}

export default TierCapsService;
